@for (toast of toastService.toasts; track toast) {
      <ngb-toast
        [class]="toast.type === 'success' ? 'bg-success text-white' : toast.type === 'danger' ? 'bg-danger text-white' : 'bg-info text-white'"
        [header]="toast.header"
        [autohide]="true"
        [delay]="toast.delay || 5000"
        (hidden)="toastService.remove(toast)"
        role="alert"
        aria-live="polite"
        aria-atomic="true"
      >
        {{ toast.body }}
      </ngb-toast>
    }